<template>
	<section class="panguin-wrapper">
		<div class="container">
			<div class="image-side">
				<img src="@/assets/images/Group.png" alt="Panguin App"/>
			</div>
			<div class="text-side">
				<div class="header">
					<img src="../../assets/images/panguin-logo.png"/>
					<div>
						<h1>اپلیکیشن آموزش زبان پنگوئن</h1>
						<p>یادگیری زبان با بازی و هیجان همراه با درآمد</p>
					</div>
				</div>
				<p class="description">
					با پنگوئن زبان یاد بگیر و سرگرم شو و درآمد خودت از یادگیریت رو نقد کن!<br> این اپ با بازی‌های جذاب، کلمات پرکاربرد رو در موقعیت‌های واقعی
					بهت آموزش میده هر
					مرحله یه چالش جدیده که هم ذهنت رو تقویت می‌کنه و هم دایره لغاتت رو گسترش میده. کلمات در
					دسته‌بندی‌های
					متنوع و برای همه سنین طراحی شدن تا یادگیری سریع و لذت‌بخش بشه.<br> با انجام تمرین‌ها و بازی‌ها، امتیاز
					بگیر و اون‌ها رو به
					جوایز واقعی تبدیل کن!🎁💸 در مدت کوتاه، پیشرفت چشمگیری در زبانت ببین و از مسیر یادگیری لذت ببر </p>
				<div class="features">
					<span>یادگیری سریع کلمات</span>
					<span>سیستم پاداش‌دهی حرفه‌ای با قابلیت نقد شدن</span>
					<span>مناسب همه سنین</span>
					<span>بازی‌های متنوع</span>
					<span>پوشش موضوعی کامل</span>
					<span>پیشرفت گام‌به‌گام با مسیر آموزشی ساختارمند</span>
				</div>
				<div class="downloads">
					<img src="../../assets/images/google-play.png" class="disabled-store" title="به‌زودی در Google Play"/>
					<img src="../../assets/images/bazar.png" class="disabled-store" title="به‌زودی در بازار"/>
					<a href="/download/panguin.apk" download>
						<img src="../../assets/images/pwa.png" alt="APK Download" />
					</a>
					<a href="https://en-app.saharmehravaran.ir/" target="_blank" rel="noopener noreferrer">
						<img src="../../assets/images/apk.png" alt="PWA" />
					</a>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name:'PanguinPage'
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.panguin-wrapper {
	background-color: #00d0c4;
	padding: 3rem 1.5rem;
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;

	.container {
		display: flex;
		flex-direction: column-reverse;
		align-items: center;
		gap: 2rem;
		width: 100%;
		max-width: 1200px;

		@media(min-width: 768px) {
			flex-direction: row-reverse;
			justify-content: space-between;
			padding: 0 2rem;
		}
	}

	.image-side img {
		max-width: 300px;
		width: 100%;
		border-radius: 16px;
	}

	.text-side {
		display: flex;
		flex-direction: column;
		max-width: 700px;

		.header {
			display: flex;
			align-items: center;
			gap: 1rem;

			img {
				width: 80px;
			}

			h1 {
				font-size: 1.5rem;
				font-weight: bold;
				color: #000;
			}

			p {
				font-size: 0.9rem;
				color: #014e4b;
				margin-top: 0.25rem;
			}
		}
	}

	.description {
		margin: 1.5rem 0;
		line-height: 2;
		font-size: 15px;
		color: #1e1e1e;
	}

	.features {
		display: flex;
		flex-wrap: wrap;
		gap: 0.5rem;

		span {
			background: #ccf6f2;
			border-radius: 9999px;
			padding: 0.4rem 1rem;
			font-size: 0.8rem;
			color: #007871;
		}
	}

	.downloads {
		margin-top: 2rem;
		display: flex;
		flex-wrap: wrap;
		gap: 1rem;

		img {
			height: 48px;
		}
		.disabled-store {
			opacity: 0.3;
			pointer-events: none;
			filter: grayscale(100%);
		}
	}
}
</style>